import { render, staticRenderFns } from "./ModalProductLabelList.vue?vue&type=template&id=65275b90&scoped=true&"
import script from "./ModalProductLabelList.vue?vue&type=script&lang=js&"
export * from "./ModalProductLabelList.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductLabelList.vue?vue&type=style&index=0&id=65275b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65275b90",
  null
  
)

export default component.exports